import { Component, OnInit } from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {FioConfig} from '../shared/classes/FioConfig';

@Component({
  selector: 'app-fio',
  templateUrl: './fio.component.html',
  styleUrls: ['./fio.component.css']
})
export class FioComponent implements OnInit {

  plusButton = true;
  editButton = false;

  createTooltip = 'fioSetting.tooltip.saveToolTip';
  deleteTooltip = 'fioSetting.tooltip.deleteToolTip';
  addTooltip = 'fioSetting.tooltip.addToolTip';

  displayedColumns: string[] = ['profile', 'token'];

  header = [
    {
      defName: 'profile',
      translation: 'fioSetting.form.profile',
      elem: 'profile'
    },
    {
      defName: 'token',
      translation: 'fioSetting.form.token',
      elem: 'token'
    }
  ];

  fioConfig: FioConfig[] | any[] = undefined;
  filteredFioConfig: FioConfig[] | any[] = undefined;

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private fioService: FioService) { }

  ngOnInit() {
    this.fioService.getAll().then(data => {
      const fioConfigs = [];
      this.fioConfig = [];
      this.filteredFioConfig = [];
      data.forEach(item => {
        const fioConfig: FioConfig = new FioConfig();
        fioConfig.id = item.id;
        fioConfig.token = item.data().token;
        fioConfig.profile = item.data().profile;
        fioConfigs.push(fioConfig);
      });
      this.fioConfig = fioConfigs;
      this.filteredFioConfig = fioConfigs;
    });
  }

  save(item){

  }

  remove(item){

  }

  loadData(config) {
    this.filteredFioConfig = config;
  }

  edit(item) {
    this.router.navigate(['/admin/settings/fio', item.id]);
  }

  add(item) {
    this.router.navigate(['/admin/settings/fio', 'new']);
  }

}
